import fp from 'lodash/fp';
import { quizAttemptStatus } from '../../../constants';
import { lastCreated } from '../../../utils';

export const questionsSelector = (state) => state.quiz.questions.result;

export const attemptsSelector = (state) => state.quiz.attempts.result;

export const isFetchingAttemptsSelector = (state) => state.quiz.attempts.isFetching;

export const lastSubmittedAnswerSelector = (state) => state.quiz.submittedAnswer.result;

export const isSubmittingAnswerSelector = (state) => state.quiz.submittedAnswer.isFetching;

export const quizRelatedTasksSelector = (state) => state.quiz.attempts.relatedTasks;

export const currentAttemptSelector = (state) =>
  fp.findLast((attempt) =>
    attempt.quizAttempt && attempt.quizAttempt.status === quizAttemptStatus.started
  )(attemptsSelector(state));

export const latestQuizAttemptSelector = (state) =>
  lastCreated((attempt) => attempt.quizAttempt)(attemptsSelector(state));

export const correctQuestionAttemptsSelector = (state) => {
  const currentAttempt = latestQuizAttemptSelector(state);

  return currentAttempt ?
    fp.filter((attempt) =>
      attempt.isCorrect
    )(currentAttempt.questionAttempts) :
    null
};



// WEBPACK FOOTER //
// ./src/state/modules/quiz/selectors.js